export function init() {
    // Get contact form
    const form = document.querySelector(".js-contact-form");

    // If form exists
    if (form) {
        // Add event listener for form submit
        form.addEventListener("submit", function (e) {
            // Prevent default form submission
            e.preventDefault();

            submitForm(form);
        });
    }
}

async function submitForm(form) {
    try {
        const successEl = form.querySelector(".js-form-success"),
            errorEl = form.querySelector(".js-form-error"),
            loadingIcon = form.querySelector(".js-loading-indicator");

        // Show loading icon
        loadingIcon.classList.add("loading");

        // Hide success and error messages
        successEl.classList.add("hidden");
        errorEl.classList.add("hidden");

        form.querySelectorAll(".js-field-error").forEach((fieldError) => {
            fieldError.remove();
        });

        // Submit form data using fetch
        const response = await fetch("/", {
            method: form.method,
            body: new FormData(form),
            headers: {
                Accept: "application/json",
            },
        });

        const json = await response.json();

        // If response is successful
        if (response.ok) {
            // Reset the form
            form.reset();

            // Show success message
            successEl.textContent = json.message ?? "Success";
            successEl.classList.remove("hidden");

            // Hide loading icon
            loadingIcon.classList.remove("loading");
        } else {
            const errorEl = form.querySelector(".js-form-error");

            // Show error message
            errorEl.textContent = json.message ?? "An error occurred";
            errorEl.classList.remove("hidden");

            // Show field-level errors
            if (json.errors) {
                Object.keys(json.errors).forEach((fieldName) => {
                    const field = form.querySelector(`[name="${fieldName}"]`),
                        fieldError = document.createElement("p");

                    fieldError.classList.add(
                        "js-field-error",
                        "text-red-800",
                        "text-sm"
                    );
                    fieldError.textContent = json.errors[fieldName];
                    field.parentNode.insertBefore(
                        fieldError,
                        field.nextSibling
                    );
                });
            }

            // Hide loading icon
            loadingIcon.classList.remove("loading");
        }
    } catch (error) {
        const errorEl = form.querySelector(".js-form-error");

        // Show error message
        errorEl.textContent = error ?? "An error occurred";
        errorEl.classList.remove("hidden");

        // Hide loading icon
        loadingIcon.classList.remove("loading");
    }
}
